/* S1 PDP Intro: rotate the bar's messages one at a time.
   Rules: one message visible; next one animates in (CSS handles the motion
   via .is-active / .is-leaving); pauses on hover/focus and when the tab is
   hidden; no rotation at all under prefers-reduced-motion (first message
   stays) or with a single message. */
const SEL = '[data-s1-intro-rotator]';

function init(rotator) {
  if (rotator.dataset.s1IntroReady) return;
  rotator.dataset.s1IntroReady = '1';
  const items = Array.from(rotator.querySelectorAll('[data-s1-intro-message]'));
  if (items.length < 2) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const interval = Math.max(2, parseInt(rotator.dataset.s1IntroInterval, 10) || 4) * 1000;
  let index = 0;
  let timer = null;
  let paused = false;

  const show = (next) => {
    const current = items[index];
    current.classList.remove('is-active');
    current.classList.add('is-leaving');
    window.setTimeout(() => current.classList.remove('is-leaving'), 600);
    items[next].classList.add('is-active');
    index = next;
  };

  const tick = () => {
    if (!paused && !document.hidden) show((index + 1) % items.length);
  };

  const start = () => {
    if (timer) window.clearInterval(timer);
    timer = window.setInterval(tick, interval);
  };

  rotator.addEventListener('mouseenter', () => { paused = true; });
  rotator.addEventListener('mouseleave', () => { paused = false; });
  rotator.addEventListener('focusin', () => { paused = true; });
  rotator.addEventListener('focusout', () => { paused = false; });
  start();
}

/* Sticky bar under a hide-on-scroll header: Impact's <store-header> slides
   itself away with a transform (no class, no CSS var change), so the bar's
   sticky top would leave a header-sized gap. Mirror the header's own rule
   (accumulated downward scroll past its threshold hides; any upward scroll
   shows) and slide the bar up by the header height at the same time. */
function initSticky(bar) {
  const wrapper = bar.closest('.shopify-section');
  if (!wrapper || wrapper.dataset.s1IntroSticky) return;
  wrapper.dataset.s1IntroSticky = '1';
  const header = document.querySelector('store-header[hide-on-scroll][sticky]');
  if (!header) return;
  if (window.matchMedia && !window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;
  const threshold = parseInt(header.getAttribute('hide-on-scroll'), 10) || 100;
  const headerHeight = () => {
    const wrap = header.closest('.shopify-section');
    return wrap ? wrap.getBoundingClientRect().height : header.getBoundingClientRect().height;
  };
  let last = window.scrollY;
  let acc = 0;
  let visible = true;
  let queued = false;
  wrapper.style.transition = 'transform 0.2s ease';
  const onScroll = () => {
    queued = false;
    const y = window.scrollY;
    if (y < 0) return;
    acc = Math.max(0, acc + (y - last));
    if (y < last) {
      if (!visible) { wrapper.style.transform = ''; visible = true; acc = 0; }
    } else if (acc > threshold && visible) {
      wrapper.style.transform = 'translateY(-' + Math.round(headerHeight()) + 'px)';
      visible = false;
    }
    last = y;
  };
  window.addEventListener('scroll', () => {
    if (!queued) { queued = true; window.requestAnimationFrame(onScroll); }
  }, { passive: true });
}

const boot = () => {
  document.querySelectorAll(SEL).forEach(init);
  document.querySelectorAll('.s1-intro--sticky').forEach(initSticky);
};
boot();
/* theme editor re-renders the section on setting changes */
document.addEventListener('shopify:section:load', boot);
